import { useRef } from "react";

const Layer = ({ id, l, selected, onDown, children, style }) => (
  <div onPointerDown={onDown(id, l)} data-testid={`design-layer-${id}`}
    className={`absolute cursor-grab touch-none active:cursor-grabbing ${selected ? "outline outline-2 outline-[#60A5FA]" : "outline-dashed outline-1 outline-white/30"}`}
    style={{ left: `${l.cx * 100}%`, top: `${l.cy * 100}%`, transform: `translate(-50%, -50%) rotate(${l.rot}deg)`, ...style }}>
    {children}
  </div>
);

export const DesignStage = ({ mockup, area, layers, selected, onSelect, onMove }) => {
  const stage = useRef(null);
  const drag = useRef(null);
  const onDown = (id, l) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    stage.current.setPointerCapture(e.pointerId);
    onSelect(id);
    drag.current = { id, x: e.clientX, y: e.clientY, cx: l.cx, cy: l.cy };
  };
  const move = (e) => {
    if (!drag.current) return;
    const r = stage.current.getBoundingClientRect();
    const clamp = (v) => Math.min(1, Math.max(0, v));
    const d = drag.current;
    onMove(d.id, { cx: clamp(d.cx + (e.clientX - d.x) / r.width), cy: clamp(d.cy + (e.clientY - d.y) / r.height) });
  };
  const up = () => { drag.current = null; };

  return (
    <div ref={stage} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onPointerDown={() => onSelect(null)}
      className="relative aspect-square w-full touch-none select-none overflow-hidden rounded-2xl border border-white/10 bg-[#0E1018]" style={{ containerType: "inline-size" }} data-testid="design-stage">
      <img src={mockup} alt="Product mockup" className="pointer-events-none absolute inset-0 h-full w-full object-contain" draggable="false" data-testid="design-mockup-image" />
      <div className="pointer-events-none absolute border-2 border-dashed border-[#60A5FA]/60" style={{ left: `${area.x}%`, top: `${area.y}%`, width: `${area.w}%`, height: `${area.h}%` }} data-testid="design-print-area">
        <span className="absolute -top-5 left-0 font-mono-label text-[10px] uppercase tracking-widest text-[#60A5FA]">Print area</span>
      </div>
      {layers.art && (
        <Layer id="art" l={layers.art} selected={selected === "art"} onDown={onDown} style={{ width: `${layers.art.w * 100}%` }}>
          <img src={layers.art.src} alt="Your artwork" draggable="false" className="pointer-events-none block w-full" data-testid="design-artwork-layer" />
        </Layer>
      )}
      {layers.texts.map((t) => (
        <Layer key={t.id} id={t.id} l={t} selected={selected === t.id} onDown={onDown}
          style={{ fontFamily: `"${t.font}"`, color: t.color, fontSize: `${t.size * 100}cqw`, lineHeight: 1, whiteSpace: "nowrap", padding: "0 .05em" }}>
          {t.text}
        </Layer>
      ))}
    </div>
  );
};
